import {
  AppState,
  Action,
  Actions,
  newImageFinishedLoading,
  newImageFailedToLoad,
  newWMSTileLayer,
} from '../app.reducer';
import { getImageSize } from '../../utils/image-size';
import { addLabelBoxAPIListeners } from './add-labelbox-api-listeners';
import { selectTileLayerWMSInformation } from '../app.selectors';
import { fetchWMSTileLayoutInformation } from './wms-info';

function parse(item: any){
  try{
    return JSON.parse(item);
  } catch(e){
    console.log('couldnt parse:', item)
    return {};
  }
}

export function onAction(
  appState: {app: AppState},
  action: Action,
  dispatch: (action: Action) => void,
) {
  if (action.type === Actions.LABELBOX_API_LOADED) {
    addLabelBoxAPIListeners(appState, action, dispatch);
  }

  if (action.type === Actions.LABELBOX_API_EMITTED_NEW_ASSET) {
    const asset = action.payload.asset;
    if (asset){
      const wmsTileLayer = selectTileLayerWMSInformation(asset.data);
      if (wmsTileLayer) {
        fetchWMSTileLayoutInformation(wmsTileLayer.tileLayerUrl).then(
          ({url, bounds, layerName}) => {
            const tileInfo = {
              wmsTileUrl: url,
              // The map bounds can be passed into the CSV
              // users do this if they have a very large tile layer
              // and they want to break it apart into smaller chunks for
              // labelers to annotate
              bounds: wmsTileLayer.bounds || bounds,
              layerName,
              minZoom: wmsTileLayer.minZoom,
              maxZoom: wmsTileLayer.maxZoom,
            };
            dispatch(newWMSTileLayer(asset, tileInfo));
          },
          (err) => console.error('Error fetching WMS info', err)
        );
      } else {
        const { imageUrl = undefined } = parse(asset.data);
        if (imageUrl) {
          getImageSize(imageUrl).then(
            (imageSize) => dispatch(newImageFinishedLoading(asset, imageSize)),
            () => dispatch(newImageFailedToLoad(imageUrl))
          );
        } else {
          console.log('asset.data does include json a key "imageUrl"', asset.data);
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/effects/index.ts